var _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversionInProgressTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Conversion_In_Progress_Tags",
    "data-name": "Conversion In Progress Tag",
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 41,
    viewBox: "0 0 81 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    fill: "#fbf8f3",
    stroke: "#b47714",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 40,
    rx: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 80,
    height: 40,
    rx: 4,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Conversion",
    transform: "translate(8 16)",
    fill: "#b47714",
    fontSize: 12,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Conversion"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "InProgress",
    transform: "translate(8 30)",
    fill: "#b47714",
    fontSize: 12,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "In Progress"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversionInProgressTag);
export default __webpack_public_path__ + "static/media/conversion_in_progress_tag.a3515c862cd573557804493207b82b50.svg";
export { ForwardRef as ReactComponent };